<template>
	<div id="mine" v-if="loaded">
		<div class="my_jf" @click="skip('/integral')">
			<div class="jf_title">
				<i class="iconfont icon-jifen"></i>
				<span>我的积分</span>
			</div>
			<div class="jf_num">85255<span>积分</span></div>
		</div>
		<div class='income'>
			<div class='top'>
				<div class='total-income'>
				  <img v-bind:src="userInfo.avatar"/>
				</div>
			</div>
			<div class='middle'>
				<div class='left'></div>
				<div class='center'>
				  <div class="name">{{userInfo.nickname}}<span>{{userInfo.driver_level.subject}}</span></div>
				</div>
				<div class='right' style="width:60px;display:block;visibility:hidden;">

				</div>
			</div>
			<div class='bottom'>
				<div class='left'>
				  <div class="number">{{otherdata.all_user_subject}}</div>
				  <div>累计答题数</div>
				  <div>正确率<span class="n">{{otherdata.right_point}}%</span></div>
				</div>
				<div class='center'>
				  <div class="point">{{otherdata.do_point}}%</div>
				  <div class='text'>已完成题库</div>
				</div>
				<div class='right'>
				  <div class="number">{{otherdata.avg_point}}</div>
				  <div>模拟考试平均分</div>
				  <div>累计考试<span class="n">{{otherdata.exam_number}}次</span></div>
				</div>
			</div>
		</div>
		
		<div class='distributio-nav'>
		  <div class='navlist' bindtap="event_businessqcode" v-if="info.business_power">
		  	<router-link :to="{path:'qcode2',query:{user_id:userInfo.id}}">
			  <div class='iconfontt icon-erweima'></div>
			  <span>{{info.child_driver_level}}代理码</span>
			</router-link>
		  </div>
		  <!--<div class='navlist' bindtap="event_sellqcode" v-if="userInfo.driver_level.distribution">
			<router-link :to="{path:'qcode1',query:{user_id:userInfo.id}}">
			  <div class='iconfontt icon-erweima' style="color:#35e195"></div>
			  <span>学员二维码</span>
			</router-link>
		  </div>
		  <div class='navlist' style="display:none"  v-if="userInfo.driver_level.distribution">
			  <div class='iconfontt icon-mingxi'></div>
			  <span>我的推广海报</span>
		  </div>
		  <div class='navlist'  v-if="userInfo.driver_level.distribution" style="display:none">
		  	<router-link to="/poster">
			  <div class='iconfontt icon-mingxi'></div>
			  <span>我的招生海报</span>
			</router-link>
		  </div>-->
		  <div class='navlist' >
		  	<router-link to="/wrong">
			  <div class='iconfontt icon-dingdan'></div>
			  <span>我的错题</span>
			</router-link>
		  </div>
		  <div class='navlist' >
		  	<router-link to="/wrong?nav_type=collect">
			  <div class='iconfontt icon-tixian-'></div>
			  <span>我的收藏</span>
			</router-link>
		  </div>
		  <div class='navlist' >
		    <router-link to="/orders">
			  <div class='iconfontt icon-dingdan'></div>
			  <span>我的订单</span>
			</router-link>
		  </div>
		  <!--<div class='navlist' >
		  	<router-link to="/distribution">
			  <div class='iconfontt icon-tuandui1' style="color:#cbb100"></div>
			  <span>我的钱包</span>
			</router-link>
		  </div>-->
		  <div class='navlist' v-on:click="event_downloadapp">
		  	<a>
			  <div class='iconfontt icon-tuandui1' style="color:#cbb100"></div>
			  <span>下载APP</span>
			</a>
		  </div>
		  <div class='navlist' v-if="otherdata.sell_power.sell_power">
		  	<router-link to="/qcode1">
			  <div class='iconfontt icon-erweima' style="color:#35e195"></div>
			  <span>学员二维码</span>
			</router-link>
		  </div>
		  <div class='navlist' >
		  	<router-link to="/profile">
			  <div class='iconfontt icon-baoming' style="color:#35e195"></div>
			  <span>个人资料</span>
			</router-link>
		  </div>
		  <!--<div class='navlist' v-if="userInfo.driver_level.distribution">
		  	<router-link to="/rewarddata">
			  <div class='iconfontt icon-zhuanxiangfanganpingshen' style="color:#c65900"></div>
			  <span>营销收入</span>
			</router-link>
		  </div>-->
		  <div class='navlist' >
		  	<router-link to="/compensate">
			  <div class='iconfontt icon-licheng' style="color:#00d52d"></div>
			  <span>考试补偿</span>
			</router-link>
		  </div>
		  <!--<div class='navlist'>
		  	<router-link to="/prize">
			  <div class='iconfont icon-weibiaoti-' style="color:#00d52d"></div>
			  <span>我的奖状</span>
			</router-link>
		  </div>
		  <div class='navlist' v-if="userInfo.driver_level.reserve">
		  	<router-link to="/yuyue">
			  <div class='iconfont icon-reserve' style="color:#00d52d"></div>
			  <span>车辆预约</span>
			</router-link>
		  </div>
		  <div class='navlist' v-if="userInfo.driver_level.reserved">
		  	<router-link to="/paiche">
			  <div class='iconfont icon-reserve' style="color:#00d52d"></div>
			  <span>我来派车</span>
			</router-link>
		  </div>
		  <div class='navlist' v-if="userInfo.driver_level.news">
		  	<router-link to="/newsadd">
			  <div class='iconfont icon-fabu' style="color:#00d52d"></div>
			  <span>信息发布</span>
			</router-link>
		  </div>
		  <div class='navlist' v-if="userInfo.driver_level.prize">
		  	<router-link to="/addprize" v-if="userInfo.driver_level.distribution">
			  <div class='iconfont icon-fabu' style="color:#00d52d"></div>
			  <span>学员颁奖</span>
			</router-link>
		  </div>-->
		</div>
	</div>
</template>

<script>
export default {
	name: 'Mine',
	data () {
		return {
			info:{},
			loaded:false,
			userInfo:{},
			otherdata:{}
		}
	},
	created (){
		this.$https.post('/api/user/info.html',this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.userInfo = res.data.data
			this.$https.post('/api/user/subjectinfo.html',this.$qs.stringify({
				token:this.$store.state.token
			})).then((res) => {
				this.otherdata = res.data.data
				this.$https.post("/api/distribution/index",this.$qs.stringify({
					token:this.$store.state.token
				})).then((res) => {
					this.info = res.data.data
					this.loaded = true
				})
			},(res) => {
				console.log(res)
			})
		},(res) => {
			console.log(res)
		})

	},
	methods:{
		event_downloadapp:function(){
			window.location.href = 'http://yk.ioccn.com/template/default/index/download_tips.html';
		},
		skip(url){
			this.$app.goTo(url)
		}
	}
}
</script>
<style scoped>
	#mine{
		background-color:#efefef;
		min-height:100vh;
		margin-bottom:50px;
	}
	/* pages/user/user.wxss */
.income{
  background: #ffffff;
}
.income .top{
  height:140px;
  background-image:url("http://jk.ioccn.com/jiakao/mine_top.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  background-position:center top;
  position:relative;
}
.income .top .total-income{
  position:absolute;
  bottom:-20px;
  width:80px;
  height:80px;
  left:50%;
  margin-left:-40px;
  border-radius:40px;
  overflow:hidden;
}
.total-income img{
	width:100%;
}
.income .top .total-income image{
  width:80px;
  height:80px;
  border-radius:40px;
}
.income .middle{
  display: flex;
  margin-top:30px;
}
.income .middle > div{
  flex: 1;
  text-align: center;
}
.income .middle .center{
  font-size:18px;
  color:#434343;
  flex:2;
}
.income .middle .center .mobile{
  color:#959595;
  font-size:14px;
  line-height:30px;
}
.income .middle .center span{
  color:#FFFFFF;
  margin-left:5px;
  background-color:#0cc8fc;
  font-size:12px;
  padding:1px 5px;
  border-radius:5px;
}
.income .bottom{
  margin-top:3vw;
  display:flex;
  padding-bottom:5vw;
}
.income .bottom div{
  flex:1;
  text-align:center;
  font-size:14px;
  color:#434343;
  line-height:22px;
}
.income .bottom div span.n{
  color:#2cd5ff;
  margin-left:5px;
}
.income .bottom div.number{
  font-size:28px;
  font-weight:bold;
  margin-bottom:10px;
}
.income .bottom .left,.income .bottom .right{
  padding-top:8vw;
}
.income .bottom .center{
  width:34vw;
  height:34vw;
  padding-top:10vw;
  display:inline-block;
  border:2px solid #eeeeee;
  border-radius:17vw;
  flex:none;
}
.income .bottom .center .point{
  color:#2cd5ff;
  font-weight:bold;
  font-size:30px;
}
.income .bottom .center .text{
  line-height:36px;
  color:#434343;
}

.withdraw-button{
  text-align: center;
  padding: 20px 0;
}
.withdraw-button button{
  width: 140px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  font-size: 16px;
  background: 0;
  color: #fff;
  border:1px solid #fff;
}
.distributio-nav{
  margin-top: 2vw;
  background: #fff;
  display: flex;
  margin-bottom: 10px;
  flex-flow: row wrap;
}
.distributio-nav .navlist{
  width: 33%;
  text-align: center;
  padding: 4vw 0;
  border-bottom:1px solid #ededed;
  border-right: 1px solid #ededed;
}
.distributio-nav span{
  font-size: 14px;
  color: #7d7d7d;
  margin-top: 3.6vw;
  display: inline-block;
}
.distributio-nav .iconfont{
  font-size: 25px;
}
.icon-mingxi{
  color: #ffba52;
}
.icon-dingdan{
  color: #46cdff;
}
.icon-tixian-{
  color: #ff6969;
}
.icon-tuandui1{
  color: #68ef7e;
}
.icon-erweima{
  color: #ff83ba;
}
.distributio-nav .num{
color: #ff515e;
}
.distributio-nav .myteam{
font-size: 14px;
color: #7d7d7d;
}
.my_jf{
	background-color: #fff;
	/* margin-top: 2vw; */
	padding: 0 .2rem;
	display: flex;
	justify-content: space-between;
	line-height: .88rem;
	background-color: #2cd5ff;
	border: 1px solid;
	border-color: rgba(250,250,250,.18);
}
.my_jf .jf_title{
	font-size: .24rem;
	color: #fff;
}
.my_jf .jf_title i{
	font-size: .24rem;
	display: inline-block;
	margin-right: .06rem;
}
.my_jf .jf_title span{
	display: inline-block;
}
.my_jf .jf_num{
	font-size: .26rem;
	color: #fff;
}
.my_jf .jf_num span{
	display: inline-block;
	font-size: .24rem;
	margin-left: .1rem;
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Mine.vue